module.exports = __webpack_public_path__ + "img/frame_medium_top.2180bf67.png";